module.exports = __webpack_public_path__ + "static/img/qrcode-box.dc04727.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/scan1/qrcode-box.png
// module id = O1Pc
// module chunks = 1